export default __webpack_public_path__ + "components/weather-icon/static/daypartcloud@3-ff1a231f3a88760ff028de78e79b5a84.png";